import * as angular from 'angular';
import EditPalletizerName, {openEditPalletizer} from "./editPalletizer.controller";
import {States} from "../../shared/config/constant.module";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {Plant} from "../../models/navigation";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import PalletizerServiceName, {PalletizerService} from "../../services/palletizers/palletizer.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import AuthDataServiceName, {AuthDataService} from "../../services/auth/authData.service";
import EquipmentServiceName, {EquipmentService} from "../../services/equipment/equipment.service";
import UIUtilityServiceName, {UIUtilityService} from "../../services/utility/uiUtility.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import * as _ from "lodash";
import {apsEnums} from "../../shared/dto/aps.enums";
import template from './palletizer.tpl.html';

let requires = [EditPalletizerName, LoaderServiceName, PalletizerServiceName, NavigationServiceName,
  AuthDataServiceName, EquipmentServiceName, UIUtilityServiceName, NotifyServiceName];

export default angular.module('aps.controller.palletizer', requires)
  .config(palletizerConfig)
  .controller('PalletizerCtrl', palletizerController)
  .name;

function palletizerConfig($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state({
    name: States.PALLETIZERS,
    url: '/admin/palletizers',
    controller: 'PalletizerCtrl as vm',
    template: template,
    data: {
      pageTitle: 'Palletizers',
      authorizeAPSIOAdmin: true
    }
  });
}

interface PalletizerController {
  palletizers: apsViewModels.PalletizerItem[];
  selectedPlant: Plant;
  plants: Plant[];

  plantChanged(): void;
  addPalletizer(): void;
  edit(instance: apsViewModels.PalletizerItem): void;
  remove(instance: apsViewModels.PalletizerItem): void;
}

function palletizerController(loaderService: LoaderService,
                              palletizerService: PalletizerService,
                              navigationService: NavigationService,
                              authDataService: AuthDataService,
                              equipmentService: EquipmentService,
                              uiUtilityService: UIUtilityService,
                              notifyService: NotifyService,
                              $modal: mm.foundation.modal) {
  let vm = {} as PalletizerController;

  let equipmentPromise = null;
  let plcs: apsViewModels.EquipmentDetail[] = null;

  let loadingPromise = navigationService.getNavigation().then(nav => {
    let plants = nav.plants();
    vm.plants = _.filter(plants, (plant: Plant) =>
      authDataService.isAPSIOAdminForPlant(plant.id)
    );

    if (nav.selectedPlant && _.includes(vm.plants, nav.selectedPlant)) {
      vm.selectedPlant = nav.selectedPlant;
    } else {
      vm.selectedPlant = _.first(vm.plants);
    }

    return loadPlantData();
  });

  loaderService.loadingPromise(loadingPromise);

  vm.plantChanged = plantChanged;
  vm.addPalletizer = add;
  vm.edit = edit;
  vm.remove = remove;
  return vm;

  function loadPlantData(): angular.IPromise<any> {
    equipmentPromise = equipmentService.get(vm.selectedPlant.id)
      .then(equipment =>
        plcs = equipment.filter(e => e.type === apsEnums.EquipmentType.PLC));

    return palletizerService.get(vm.selectedPlant.id)
      .then(palletizers => vm.palletizers = palletizers);
  }

  function plantChanged(): void {
    vm.palletizers = null;
    loaderService.loadingPromise(loadPlantData());
  }

  function add(): void {
    edit(null);
  }

  function edit(instance: apsViewModels.PalletizerItem): void {
    if (!equipmentPromise) {
      return;
    }

    equipmentPromise.then(() => {
      let result = openEditPalletizer({
        plant: vm.selectedPlant,
        palletizer: instance,
        plcs: plcs
      }, $modal);

      result.then((result) => {
        if (!result) {
          return;
        }

        let shopName = 'No Shop';
        if (result.shopId) {
          shopName = _.find(vm.selectedPlant.shops, {id: result.shopId}).name;
        }
        let plc = _.find(plcs, {id: result.equipmentId});
        let dataPoint = _.find(plc.dataPoints, {id: result.dataPointId});
        if (instance) {
          _.assign(instance, result);
        } else {
          instance = _.assign<apsViewModels.PalletizerItem>({}, result);
          vm.palletizers.push(instance);
        }
        instance.shopName = shopName;
        instance.equipmentName = plc.name;
        instance.dataPointName = dataPoint.name;
      });
    });
  }

  function remove(instance: apsViewModels.PalletizerItem): void {
    uiUtilityService.confirm('Are you sure you want to remove palletizer: ' + instance.name + '?',
      'Remove Palletizer?').then(confirmed => {
      if (!confirmed) {
        return;
      }

      loaderService.loadingPromise(palletizerService.remove({
        id: instance.id,
        plantId: instance.plantId
      }).then(() => {
        _.remove(vm.palletizers, instance);
      }, notifyService.handleApiErrors));
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/palletizers/palletizer.controller.ts